module.exports = __webpack_public_path__ + "static/media/Northridge-Villas-Master-Deed-By-Laws.0134b5d7.pdf";